import { crudeAxios } from '../../helpers/crude_api_helper';
import { buildReportParams } from './reportConstants';

// Export is server-generated: the API renders the Excel/PDF and the FE only
// downloads the resulting blob.
//
// ⚠️ The export endpoints accept `page`/`pageSize` but IGNORE them — they always
// return EVERY row matching the active filters, not just the page on screen.
// So only the filters are sent.
//
// crudeAxios' response interceptor already unwraps `response.data`, so the
// awaited value here IS the Blob.
const buildQuery = params => {
  const entries = Object.entries(params || {}).filter(
    ([, value]) => value !== null && value !== undefined && value !== ''
  );
  if (!entries.length) return '';
  return `?${entries
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join('&')}`;
};

export const downloadReport = async (endpoint, filters, filename) => {
  const blob = await crudeAxios.get(
    `${endpoint}${buildQuery(buildReportParams(filters))}`,
    { responseType: 'blob' }
  );
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export default downloadReport;
